import React from "react";
import classnames from "classnames";
import { connect } from "react-redux";
import { Outlet } from "react-router-dom";
import { RootState } from "../../../../../../models";
import { BreadcrumbsWrapper, ConnectedAlert, ProgressBar } from "../../../../components";
import { selectors as LOADING_SELECTORS } from "../../../../loading";
import "./PrepaidRefillPage.less";

interface PrepaidRefillPageProps {
    className?: string;
    isFetchingData: boolean;
}

const PrepaidRefillPage: React.FC<PrepaidRefillPageProps> = ({ className = "", isFetchingData }) => {
    return (
        <div
            className={classnames("prepaid-refill-page", {
                [className]: className,
            })}
        >
            <div className="prepaid-refill-page__heading-container">
                <div className="prepaid-refill-page__heading-inner">
                    <ProgressBar isFetchingData={isFetchingData} backgroundColor="white" />
                    <BreadcrumbsWrapper
                        breadcrumbs={[
                            { name: "Kontantkort", link: "/mobilabonnement/kontantkort" },
                            { name: "Påfyll", link: "/mobilabonnement/kontantkort/lade/" },
                        ]}
                    />
                    <ConnectedAlert />
                </div>
            </div>
            <div className="prepaid-refill-page__content">
                <Outlet />
            </div>
        </div>
    );
};

const mapStateToProps = (state: RootState) => ({
    isFetchingData: LOADING_SELECTORS.isLoading(state),
});

export default connect(mapStateToProps)(PrepaidRefillPage);
